import { keyframes } from 'styled-components';

export const ANIMATIONS = {
  easing: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
  delay: '150ms',
  animationEasing: 'ease-in',
};

export const popAndBounce = keyframes`
  0%   { transform: rotate(45deg) scale(1,1)      translateY(0); }
  10%  { transform:               scale(1.1,.9)   translateY(0); }
  30%  { transform:               scale(.9,1.1)   translateY(-10px); }
  50%  { transform:               scale(1.05,.95) translateY(0); }
  57%  { transform:               scale(1,1)      translateY(-1px); }
  64%  { transform:               scale(1,1)      translateY(0); }
  100% { transform: rotate(0deg)  scale(1,1)       translateY(0); }
`;

export const popAndBounceReverse = keyframes`
  0%   { transform: rotate(0deg)  scale(1,1)      translateY(0); }
  10%  { transform:               scale(1,1)      translateY(0); }
  30%  { transform:               scale(1,1)      translateY(-1px); }
  50%  { transform:               scale(1.05,.95) translateY(0); }
  57%  { transform:               scale(.9,1.1)   translateY(-10px); }
  64%  { transform:               scale(1.1,.9)   translateY(0); }
  100% { transform: rotate(45deg) scale(1,1)      translateY(0); }
`;

export const pop = keyframes`
  0%   { transform: scale(1); }
  10%  { transform: scale(.7); }
  30%  { transform: scale(.9); }
  50%  { transform: scale(1); }
  57%  { transform: scale(1.1); }
  64%  { transform: scale(1.3); }
  100% { transform:  scale(1); }
`;
export const popReverse = keyframes`
  0%   { transform: scale(1); }
  10%  { transform: scale(1.1); }
  30%  { transform: scale(1.2); }
  50%  { transform: scale(1); }
  57%  { transform: scale(.9); }
  64%  { transform: scale(.8); }
  100% { transform: scale(1); }
`;
